import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Title, Text as Paragraph } from '../../components/Typography';

export const Container = tw.section`
  max-w-none
  overflow-hidden
  p-0
`;
export const GridContent = tw.div`
  text-center
  md:mb-30
  sm:mb-50
`;
export const SubHeading = tw(Paragraph)`
  mb-2.5
`;
export const Heading = tw(Title)`
  mb-5
`;
export const Description = tw(Paragraph)`
  sm:w-full
  md:w-3/5
  mx-auto
`;
export const GridWrapper = tw.div`
  relative
  overflow-hidden
`;
export const Image = tw.img`
  absolute
  md:top-0
  sm:-top-10
  right-0
  z-10
  md:w-1/5
  sm:w-3/12
`;
export const StaticBlob = tw.div`
  absolute
  sm:-top-12
  md:top-0
  sm:-right-5
  md:-right-20
  sm:w-150
  md:w-1/5
`;
export const MobileSlider = styled.div<{ $ctaExists: boolean }>`
  position: relative;
  ${({ $ctaExists }) => !$ctaExists && 'padding-bottom: 55px;}'}
`;

export const CarouselCard = styled.div`
  margin-right: 15px;
  min-width: 100%;
  @media (min-width: 768px) {
    min-width: 32%;
  }
`;
CarouselCard.displayName = 'CarouselCard';
